export default __webpack_public_path__ + "static/media/img.821ea21d.jpg";